type MonthlyPrice = {
  pricingModel: "fixed" | "per_seat";
  baseSeats: number;
  basePricePerMonth: number;
  additionalSeatPricePerMonth?: number | null;
};

export function getCurrencyLabel(currency: string) {
  return currency.toUpperCase() === "EUR" ? "€" : currency.toUpperCase();
}

export function formatMonthlyPrice(
  price: MonthlyPrice,
  currency: string,
) {
  const currencyLabel = getCurrencyLabel(currency);

  if (price.pricingModel === "fixed") {
    return price.basePricePerMonth === 0
      ? "Free"
      : `${price.basePricePerMonth} ${currencyLabel}/month`;
  }

  const monthlySeatPrice =
    price.additionalSeatPricePerMonth ?? price.basePricePerMonth;
  const baseSeats = Math.max(price.baseSeats, 1);
  const baseSeatLabel = baseSeats === 1 ? "seat" : "seats";

  return `${price.basePricePerMonth} ${currencyLabel}/month for ${baseSeats} ${baseSeatLabel}\n+ ${monthlySeatPrice} ${currencyLabel}/additional seat/month`;
}
